import { LoadingOutlined } from "@ant-design/icons";
import MainWrapper from "../../components/MainWrapper";
import { useAppSelector } from "../../redux/hooks";
import CompanySection from "./CompanySection";
import InfoSection from "./InfoSection";
import PlanSection from "./PlanSection";
import SettingSection from "./SettingSection";

const ProfilePage = () => {
    const { processing } = useAppSelector(state => state.auth);
    return (
        <MainWrapper className="bg-2">
            <div className="container-lg container-fluid">
                <div className="row">
                    <div className="col-md-9 mx-auto">
                        <PlanSection />
                        {processing && (
                            <div className="d-flex justify-content-end">
                                <small className="text-info me-2">saving changes...</small>
                                <LoadingOutlined />
                            </div>
                        )}
                        <CompanySection />
                        <InfoSection />
                        <SettingSection />
                    </div>
                </div>
            </div>
        </MainWrapper>
    );
};

export default ProfilePage;
